import axios from '../../axios';
// 领料出库单列表
export const getStkOutMaterialPage = data => {
  return axios({
    url: '/api/sys/stk/getStkOutMaterialPage',
    method: 'post',
    data
  })
};
// 领料出库单列表保存
export const saveStkOutMaterialSerial = data => {
  return axios({
    url: '/api/sys/stk/saveStkOutMaterialSerial',
    method: 'post',
    data
  })
};
// 领料出库单列表修改
export const updateStkOutMaterial = data => {
  return axios({
    url: '/api/sys/stk/updateStkOutMaterial',
    method: 'post',
    data
  })
};
// 领料出库单列表删除
export const deleteStkOutMaterials = data => {
  return axios({
    url: '/api/sys/stk/deleteStkOutMaterials',
    method: 'post',
    data
  })
};
// 领料出库单列表审核
export const auditOutMaterial = data => {
  return axios({
    url: '/api/sys/stk/auditOutMaterial',
    method: 'post',
    data
  })
};
// 领料出库单列表反审核
export const unAuditOutMaterial = data => {
  return axios({
    url: '/api/sys/stk/unAuditOutMaterial',
    method: 'post',
    data
  })
};
// 领料出库单列表作废
export const invalidOutMaterial = data => {
  return axios({
    url: '/api/sys/stk/invalidOutMaterial',
    method: 'post',
    data
  })
};
// 领料出库单明细列表
export const getStkOutMaterialEntryPage = data => {
  return axios({
    url: '/api/sys/stk/getStkOutMaterialEntryPage',
    method: 'post',
    data
  })
};
// 领料出库单明细列表删除
export const deleteStkOutMaterialEntrys = data => {
  return axios({
    url: '/api/sys/stk/deleteStkOutMaterialEntrys',
    method: 'post',
    data
  })
};
// 领料出库单
export const getStkOutMaterialBySourceVoucher = data => {
  return axios({
    url: '/api/sys/stk/getStkOutMaterialBySourceVoucher',
    method: 'post',
    data
  })
};
// 领料出库单明细序列号列表
export const getStkOutMaterialSerialPage = data => {
  return axios({
    url: '/api/sys/stk/out/material/serial/getStkOutMaterialSerialPage',
    method: 'post',
    data
  })
};
// 领料退货单列表
export const getStkOutMaterialReturnPage = data => {
  return axios({
    url: '/api/sys/stk/getStkOutMaterialReturnPage',
    method: 'post',
    data
  })
};
// 保存领料退货单
export const saveStkOutMaterialReturnSerial = data => {
  return axios({
    url: '/api/sys/stk/saveStkOutMaterialReturnSerial',
    method: 'post',
    data
  })
};
// 修改领料退货单
export const updateStkOutMaterialReturn = data => {
  return axios({
    url: '/api/sys/stk/updateStkOutMaterialReturn',
    method: 'post',
    data
  })
};
// 删除领料退货单
export const deleteStkOutMaterialReturns = data => {
  return axios({
    url: '/api/sys/stk/deleteStkOutMaterialReturns',
    method: 'post',
    data
  })
};
// 作废领料退货单
export const cancelStkOutMaterialReturns = data => {
  return axios({
    url: '/api/sys/stk/cancelStkOutMaterialReturns',
    method: 'post',
    data
  })
};
// 审核领料退货单
export const auditStkOutMaterialReturns = data => {
  return axios({
    url: '/api/sys/stk/auditStkOutMaterialReturns',
    method: 'post',
    data
  })
};
// 领料退货单物料明细
export const getStkOutMaterialReturnEntryPage = data => {
  return axios({
    url: '/api/sys/stk/getStkOutMaterialReturnEntryPage',
    method: 'post',
    data
  })
};
// 领料退货单物料序列号明细
export const getStkOutMaterialReturnSerialPage = data => {
  return axios({
    url: '/api/sys/stk/out/material/return/getStkOutMaterialReturnSerialPage',
    method: 'post',
    data
  })
};

// 调拨单列表
export const getStkMovePage = data => {
  return axios({
    url: '/api/sys/stk/getStkMovePage',
    method: 'post',
    data
  })
};
// 保存调拨单
export const saveStkMove = data => {
  return axios({
    url: '/api/sys/stk/saveStkMove',
    method: 'post',
    data
  })
};
// 修改调拨单
export const updateStkMove = data => {
  return axios({
    url: '/api/sys/stk/updateStkMove',
    method: 'post',
    data
  })
};
// 删除调拨单
export const deleteStkMoves = data => {
  return axios({
    url: '/api/sys/stk/deleteStkMoves',
    method: 'post',
    data
  })
};
// 作废调拨单
export const cancelStkMoves = data => {
  return axios({
    url: '/api/sys/stk/cancelStkMoves',
    method: 'post',
    data
  })
};
// 审核调拨单
export const auditStkMoves = data => {
  return axios({
    url: '/api/sys/stk/auditStkMoves',
    method: 'post',
    data
  })
};
// 反审核调拨单
export const unAuditStkMoves = data => {
  return axios({
    url: '/api/sys/stk/unAuditStkMoves',
    method: 'post',
    data
  })
};
// 调拨单物料明细列表
export const getStkMoveEntryPage = data => {
  return axios({
    url: '/api/sys/stk/getStkMoveEntryPage',
    method: 'post',
    data
  })
};
// 调拨单序列号明细列表
export const getStkMoveSerialPage = data => {
  return axios({
    url: '/api/sys/stk/getStkMoveSerialPage',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/stk/MaterialIssueDoc.js